<template>
  <div>
  <div class="page-login__content">Use the form below to sign in to your personal member area.</div>
    <form @submit.prevent="login">
      <div class="row page-login__sign-in-row">
        <div class="page-login__input col-md-6">
          <input
              class="page-login__login-input list-group-item form-control"
              type="text"
              v-model="email"
              placeholder="email" />
        </div>
        <div class="page-login__input col-md-6">
          <input
              class="list-group-item form-control page-login__login-input"
              type="password"
              v-model="password"
              name="password"
              placeholder="password" />
        </div>
      </div>
      <div class="row text-center">
        <div class="col">
          <button class="page-login__login-btn" type="submit" :disabled="!isFormValid">Sign in</button>
        </div>
      </div>
      <div class="row text-center">
        <div class="col">
          <a class="page-login__trouble-link" @click.prevent="toReset">Trouble signing in?</a>
        </div>
      </div>
    </form>
  </div>
</template>

<script>
  export default {
    name: 'LoginForm',
    mounted() {
      this.$store.dispatch('main/setProperty', { key: 'globalLoading', value: false });
    },
    data() {
      return {
        email: '',
        password: '',
        loading: false,
      };
    },
    watch: {
      loading() {
        this.$store.dispatch('main/setProperty', { key: 'globalLoading', value: this.loading });
      },
    },
    computed: {
      isEmailValid() {
        return (/^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(\.[a-zA-Z0-9-]+)+$/.test(this.email));
      },
      isFormValid() {
        return this.isEmailValid && this.password != '';
      },
    },
    methods: {
      login() {
        this.loading = true;
        this.$store.dispatch('auth/login', { email: this.email, password: this.password })
          .then(() => {
            if (!this.$store.state['auth/error']) {
              console.log('redirecting to dash');
              this.$router.push({ name: 'dashboard' });
            }
          })
          .catch(() => {
            this.loading = false;
            this.password = null;
            this.error = true;
          })
      },
      toReset() {
        this.$store.dispatch('auth/setProperty', { key: 'error', value: false });
        this.$store.dispatch('auth/setProperty', { key: 'message', value: null });
        this.$router.push({ name: 'reset' });
      },
    },
  };
</script>
